export const HOTJAR_SCRIPT_ID = 'hotjar-tracking-script';
const HOTJAR_SCRIPT_SRC_PREFIX = 'https://static.hotjar.com/c/hotjar-';

let hotjarInitialized = false;

const isBrowser = () => typeof window !== 'undefined' && typeof document !== 'undefined';
const getExistingHotjarScript = () =>
  document.getElementById(HOTJAR_SCRIPT_ID) ||
  document.querySelector(`script[src^="${HOTJAR_SCRIPT_SRC_PREFIX}"]`);

export const initializeHotjar = hotjarConfig => {
  if (!isBrowser()) {
    return false;
  }

  const siteId = Number(hotjarConfig?.siteId);
  const scriptVersion = Number(hotjarConfig?.scriptVersion);

  if (!siteId || !scriptVersion) {
    return false;
  }

  if (hotjarInitialized || window.hj || getExistingHotjarScript()) {
    hotjarInitialized = true;
    return false;
  }

  const head = document.head || document.getElementsByTagName('head')[0];
  if (!head) {
    return false;
  }

  window.hj =
    window.hj ||
    function hotjar() {
      (window.hj.q = window.hj.q || []).push(arguments);
    };
  window._hjSettings = {
    hjid: siteId,
    hjsv: scriptVersion,
  };

  const script = document.createElement('script');
  script.id = HOTJAR_SCRIPT_ID;
  script.async = true;
  script.src = `${HOTJAR_SCRIPT_SRC_PREFIX}${siteId}.js?sv=${scriptVersion}`;
  head.appendChild(script);

  hotjarInitialized = true;
  return true;
};

export const resetHotjarInitialization = () => {
  hotjarInitialized = false;
};
